/** @format */

import React from 'react';
import Table from 'react-bootstrap/Table';
import { FACTS_FIELD_KEYS } from '../utilities';
import './styles.scss';

export const getAreaData = (props) => {
  const { dataSet, objectText } = props;

  const factKey = FACTS_FIELD_KEYS.AREA;

  const areaData = dataSet[factKey];

  const AreaDataTable = () => {
    const TableRow = ({ rowData }) => {
      const {
        other,
        water,
        arabel,
        forest,
        infield,
        pasture,
        totalArea,
        wasteLand,
        areaSource
      } = rowData || {};

      return (
        <tr>
          <td>{areaSource}</td>
          <td>{water}</td>
          <td>{arabel}</td>
          <td>{forest}</td>
          <td>{infield}</td>
          <td>{pasture}</td>
          <td>{wasteLand}</td>
          <td>{other}</td>
          <td>{totalArea}</td>
        </tr>
      );
    };

    if (Array.isArray(areaData?.areaData) && areaData.areaData.length > 0) {
      return (
        <>
          <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
            <div className='object-listing-accordian-list-left'>
              {objectText?.[factKey]?.areaData?.label}
            </div>
            <div className='object-listing-accordian-list-right'></div>
          </div>
          <Table striped responsive>
            <thead>
              <tr>
                <th>{objectText?.area?.areaData?.areaSource?.label}</th>
                <th>{objectText?.area?.areaData?.water?.label}</th>
                <th>{objectText?.area?.areaData?.arabel?.label}</th>
                <th>{objectText?.area?.areaData?.forest?.label}</th>
                <th>{objectText?.area?.areaData?.infield?.label}</th>
                <th>{objectText?.area?.areaData?.pasture?.label}</th>
                <th>{objectText?.area?.areaData?.wasteLand?.label}</th>
                <th>{objectText?.area?.areaData?.other?.label}</th>
                <th>{objectText?.area?.areaData?.totalArea?.label}</th>
              </tr>
            </thead>
            <tbody>
              {areaData.areaData.map((data, index) => (
                <TableRow key={index} rowData={data} />
              ))}
            </tbody>
          </Table>
        </>
      );
    }
    return <></>;
  };

  const AreaSection = () => {
    return (
      <div className='area-data-body'>
        <div className='object-listing-accordian-list object-listing-accordian-list-no-border'>
          <div className='object-listing-accordian-list-left'>
            {objectText?.[factKey]?.area?.label}
          </div>
          <div className='object-listing-accordian-list-right'>
            {areaData?.area}
          </div>
        </div>
        <AreaDataTable />
      </div>
    );
  };

  return {
    component: <AreaSection />,
    factsCount: areaData?.areaData.length || 0
  };
};
